import Skeleton from '@mui/material/Skeleton';
import { HTMLAttributes } from 'react';
import PureLink from '../../../common/Link/PureLink';
import styles from './Header.module.scss';
import { useScorm } from '../../../../lib/context/ScormContext';
import ErrorInfo from '../../base/ErrorInfo/ErrorInfo';
import { Label } from '../../../common/Label/Label';
import { HEADER_LABEL_KEYS } from '../../../../lib/constants/labelKeys';
import RefreshLoader from '../../../common/RefreshLoader/RefreshLoader';
import { classes } from '../../../../lib/utils/cssUtils';
import { headerTestIds } from '../../../../lib/tests/testIds';
import { useConfig } from '../../../../lib/hooks/config';

const DownloadsListCounter = ({ className, ...rest }: HTMLAttributes<HTMLAnchorElement>) => {
  const { downloadsList } = useScorm();
  const { downloadsListPage } = useConfig() ?? {};
  const isActionPending = downloadsList?.isValidating && !downloadsList?.isLoading;

  if (downloadsList?.error) {
    return (
      <ErrorInfo
        internal
        className={styles.counterErrorContainer}
        classNames={{ topContainer: styles.errorTopContainer }}
      />
    );
  }

  if (downloadsList?.isLoading) {
    return <Skeleton className={styles.counterSkeleton} />;
  }

  if (!downloadsList || !downloadsList.data) {
    return null;
  }

  return (
    <PureLink href={downloadsListPage} className={classes(styles.counterLink, className)} {...rest}>
      {isActionPending && <RefreshLoader />}
      <Label name={HEADER_LABEL_KEYS.MENU_DOWNLOAD_LIST_LABEL} className={styles.counterLabel} />
      <span className={styles.counter} data-testid={headerTestIds.downloadsCounter}>
        {downloadsList.data.length}
      </span>
    </PureLink>
  );
};

export default DownloadsListCounter;
